<div class="pc-page-shell">
 <div class="filter-container" [class.open]="isFilterOpen">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

    <!-- Header -->
    <div class="filter-header">
      <div class="filter-header__title">
        <mat-icon aria-hidden="true">filter_alt</mat-icon>
        <span>Table Filter</span>
      </div>
      <mat-icon class="close-btn" (click)="isFilterOpen = false">close</mat-icon>
    </div>

    <!-- Body -->
    <form [formGroup]="filterForm" class="filter-body">

      <div class="filter-section">
        <h4>Date Range</h4>

        <app-custom-date-picker
          [label]="'From Date'"
          [controlname]="filterForm.controls['from_date']">
        </app-custom-date-picker>

        <app-custom-date-picker
          [label]="'To Date'"
          [controlname]="filterForm.controls['to_date']">
        </app-custom-date-picker>
      </div>

      <div class="filter-section">
        <h4>Segment</h4>

        <app-pc-multi-select-filter
          label=""
          placeholder="Select Segment"
          allLabel="All"
          [options]="segmentOptions"
          [lightMode]="!isDarkMode()"
          [(selected)]="selectedSegments">
        </app-pc-multi-select-filter>
      </div>

      <div class="filter-section">
        <h4>Ship Name</h4>

        <input
          type="text"
          class="form-control ship-input"
          formControlName="shipName"
          (input)="filterShipNames($event)"
          [matAutocomplete]="autoShip"
          placeholder="Select Ship Name"
        />

        <mat-autocomplete #autoShip="matAutocomplete">
          <mat-option
            *ngFor="let ship of shipNameSuggestions"
            [value]="ship.vessel_name">
            {{ ship.vessel_name }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="filter-section">
        <h4>I.M.O Number</h4>

        <app-custom-input
          placeholder="I.M.O Number"
          label=""
          [controlname]="filterForm.controls['imoNumber']">
        </app-custom-input>
      </div>

      <div
        class="filter-section"
        *ngIf="username === 'Meraki - Operations'">
        <h4>Client</h4>
        <app-pc-multi-select-filter
          label=""
          placeholder="Select Client"
          allLabel="All"
          [options]="clientOptions"
          [lightMode]="!isDarkMode()"
          [(selected)]="selectedClients">
        </app-pc-multi-select-filter>
      </div>

    </form>

    <!-- Footer -->
    <div class="filter-footer">
      <button
        type="button"
        class="btn clear-btn"
        (click)="clearClick()">
        <mat-icon>clear_all</mat-icon>
        Clear Filter
      </button>

      <button
        type="button"
        class="btn apply-btn"
        (click)="filterClick()">
        <mat-icon>filter_list</mat-icon>
        Apply Filter
      </button>
    </div>

  </div>
</div>
<div class="filter-overlay" *ngIf="isFilterOpen" (click)="isFilterOpen = false"></div>

<div class="container">
  <p class="title">
  Port Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Fleet
    View
  </p>
  <div class="top-actions">
 <mat-icon
  class="filter-top-btn"
  (click)="isFilterOpen = true"
  matTooltip="Table Filter">
  filter_list
</mat-icon>
</div>
  <div class="row content-row">
    <div class="col-12 map-wrapper">
      <div id="pcFleetMap" class="map-container"></div>
    </div>

    <div class="col-12 table-wrapper">
      <div class="table-header">
        <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
          Fleet View Table
        </h2>
  <div class="fleet-toggle">
          <button [class.active]="!isAtPortView" (click)="setView(false)">
            At Sea
          </button>

          <button [class.active]="isAtPortView" (click)="setView(true)">
            At Port
          </button>
        </div>
        <!-- <span class="text-right togglebtn"
       
          >
          <button
            class="btn btn-light hover-button apply refresh"
            (click)="editClick()"
             *ngIf="username ==='Meraki - Operations'"
          >
            <span class="name">Update Vessel Status</span>
          </button></span
        > -->
      </div>
      <div class="detail-rail-table-wrapper pc-performance-table-wrapper">
      <div
        class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
        [class.pc-data-table--dark]="isDarkMode()"
      >
        <table
          class="pc-performance-table mat-elevation-z8 printable-table"
          #table
          id="style-4"
          matSort
          [ngClass]="{ 'dark-table': isDarkMode() }"
        >
          <thead class="sticky-header">
            <tr>
              <th class="th-text-centersno" mat-sort-header="sNo">Sr No</th>
              <th class="th-text-center2">Ship View</th>
              <th class="fixed-head th-text-center3" mat-sort-header="vessel_name">
                Vessel Name
              </th>
              <th class="th-text-center2" mat-sort-header="vessel_imo">IMO No</th>
              <th class="th-text-center" mat-sort-header="client">Client</th>
              <th class="th-text-center" mat-sort-header="segment">Segment</th>
              <th class="th-metric">
                <span class="pc-col-header">
                  <span class="pc-col-header__label">Warranty Variance (MT)</span>
                  <mat-icon class="pc-col-header__info" matTooltip="Under Performance Against Warranties (MT). Loss in red, gain in green.">info</mat-icon>
                </span>
              </th>
              <th class="th-metric">
                <span class="pc-col-header">
                  <span class="pc-col-header__label">Technical Variance (MT)</span>
                  <mat-icon class="pc-col-header__info" matTooltip="Under Performance Against Technical Baseline Consumption (MT). Loss in red, gain in green.">info</mat-icon>
                </span>
              </th>
              <th class="th-kpi">
                <span class="pc-col-header">
                  <span class="pc-col-header__label">CP Gain/Loss (MT)</span>
                  <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per CP (MT). Loss in red, gain in green.">info</mat-icon>
                </span>
              </th>
              <th class="th-kpi">
                <span class="pc-col-header">
                  <span class="pc-col-header__label">Technical Gain/Loss (MT)</span>
                  <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per Technical Baseline (MT). Loss in red, gain in green.">info</mat-icon>
                </span>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="isLoadingTable">
            <tr *ngFor="let dummy of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="skeleton-row">
              <td><div class="skeleton-bar sno-skeleton"></div></td>
              <td><div class="skeleton-bar icon-skeleton"></div></td>
              <td class="fixed-col"><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
              <td><div class="skeleton-bar"></div></td>
            </tr>
          </tbody>
          <tbody *ngIf="!isLoadingTable">
            <tr *ngFor="let element of paginatedData; let rowIndex = index">
              <td>
                <input
                  *ngIf="edit"
                  type="checkbox"
                  class="checkBox"
                  (change)="onCheckboxChange($event, element)"
                />
                {{ rowIndex + 1 }}
              </td>

              <td>
                <button
                  class="gradient-btn"
                  (click)="showDetails(element)"
                  [ngStyle]="{
                    'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                    'border-radius': '11px',
                    border: 'none'
                  }"
                  matTooltip="Port Consumption Detail"
                  matTooltipPosition="above"
                  aria-label="View port consumption detail">
                  <mat-icon
                    fontSet="material-icons-outlined"
                    fontIcon="visibility"
                    class="visiblityIcon">visibility_outlined</mat-icon>
                </button>
              </td>

              <td class="fixed-col">
                {{ formatVesselName(element.vessel_name) }}
              </td>
              <td>{{ element.vessel_imo }}</td>
              <td>{{ formatVesselName(element.client || '') || '—' }}</td>
              <td>
                <span [ngStyle]="getDynamicSegmentStyle(element.segment)">
                  {{ formatSegment(element.segment) }}
                </span>
              </td>

              <td
                [ngStyle]="getWarrantedStyle(element)"
                [matTooltip]="getWarrantedTooltip(element)"
                [matTooltipClass]="tooltipClass"
                matTooltipPosition="above"
              >
                {{ getWarrantyVariance(element).toFixed(2) }}
              </td>
              <td
                [ngStyle]="getTotalDesignStyle(element)"
                [matTooltip]="getDesignTooltip(element)"
                [matTooltipClass]="tooltipClass"
                matTooltipPosition="above"
              >
                {{ getTechnicalVariance(element).toFixed(2) }}
              </td>
              <td [ngStyle]="getCpLossGainStyle(element)">
                {{ getTotalWarrantedConsumption(element) }}
              </td>
              <td [ngStyle]="getTechnicalLossGainStyle(element)">
                {{ getTotalDesignConsumption(element) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
      <mat-paginator
        class="pc-performance-paginator"
        [length]="filteredData ? filteredData.length : elements?.length"
        [pageSizeOptions]="[100]"
        [pageSize]="itemsPerPage"
        (page)="onPageChange($event)"
        showFirstLastButtons
        [ngClass]="{ 'dark-paginator': isDarkMode() }"
      ></mat-paginator>

      <br />
      <div class="text-right">
        <button class="btn btn-light hover-button mail" (click)="exportClick()">
          <mat-icon>download</mat-icon>&nbsp; Export
        </button>
      </div>
    </div>
  </div>

  <br />
</div>
</div>
